import { Command } from 'pos/common';

import { Preconditions } from 'core/infrastructure-next';
import { Result } from 'core/infrastructure';
import { Permission, FlowAction } from 'core/api';

import endPendingTickets, { canCloseDayWithPendingTickets } from './endPendingTickets';
import deleteTrainingActivity from './deleteTrainingActivity';
import makeBalance from './makeBalance';
import extractPendingTipsIfNeeded from './extractPendingTipsIfNeeded';
import { ThemeManager } from 'pos/ui';
import * as CloseDayStore from './CloseDayStore';

declare global {
	interface CommandType {
		closeDay: () => Promise<Result<FlowAction>>
	}
}

Command.register('closeDay', Preconditions.and(Preconditions.ensure(Permission.Pos_CloseDay), Preconditions.ensureIsMaster), async (): Promise<Result<FlowAction>> => {

	await CloseDayStore.reloadPendingTickets();

	const canBeClosed = ThemeManager.isWebPos()
		? (await endPendingTickets()).ok
		: (await canCloseDayWithPendingTickets());

	if (!canBeClosed)
		return Result.error();

	const success = await deleteTrainingActivity();
	if (!success)
		return Result.error();

	await extractPendingTipsIfNeeded();

	return await makeBalance();
});
